export class TreeResult {
  code: number;
  data: any = {};

  static ok(value: TreeResult) { return value.code === 0; }
}